import * as React from 'react';
import cx from "classnames";
import PropTypes from 'prop-types';
import StandardCard from '@/components/cards/StandardCard';
import LinkButton from '@/components/LinkButton';
import { useTranslation } from "@/hooks/translation";
import LoginModal from '@separate/components/LoginModal';
import styles from './fullPageSingleArticle.module.scss';

export default function Actions(props) {
  const { isLoggedIn, ...extraProps } = props;
  const { t } = useTranslation();

  const [showLogin, setShowLogin] = React.useState(false);

  return (
    <div className={styles.overlay}>
      <StandardCard>
        <h3 className="mb-3">{t(`articles.premium.message.title`)}</h3>
        <div className="mb-3 d-flex flex-column">
          <LinkButton
            href="/premium"
            className="py-2 px-3 align-self-center text-decoration-none"
          >
            {t(`articles.premium.message.cta`)}
          </LinkButton>
          <span className="my-1">or</span>
          <LinkButton
            href="/"
            className={cx(styles.homeLink, "d-flex align-items-center justify-content-center align-self-center px-4 py-2 text-decoration-none")}
          >
            {t("articles.premium.message.home")}
          </LinkButton>
        </div>
        {!isLoggedIn &&
          <p className="mb-0">{t(`articles.premium.message.member`)} <a onClick={() => setShowLogin(true)}>{t(`articles.premium.message.link`)}</a></p>
        }
      </StandardCard>
      <LoginModal show={showLogin} onHide={() => setShowLogin(false)} />
    </div>
  );
}

Actions.propTypes = {
  isLoggedIn: PropTypes.bool,
};
